import * as React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Text, Image, View } from "@react-pdf/renderer";
import topImage from "../../../assets/pdf-export/top-image.png";
import tdcImage from "../../../assets/pdf-export/tdc.png";
import { styles } from "./styles";

export const PageHeader: React.FC = () => (
  <>
    <View style={styles.topView} fixed>
      <Image source={topImage} />
      <View style={styles.overlay} />
      <Image source={tdcImage} style={styles.tdcImage} />
      <View style={styles.topTextWrapper}>
        <Text style={styles.topText}>MEET THE</Text>
        <Text style={styles.topText}>EXPERTS</Text>
      </View>
    </View>
    <View style={styles.gold}>
      <Text style={styles.goldText}>
        The Desire Company is a platform for true experts to share their
        hard-earned knowledge.
      </Text>
      <Text style={styles.goldText}>
        Our Experts share their real experiences of using your products to build
        your customers confidence.
      </Text>
      <Text style={styles.goldLarge}>
        EXPERT ADVICE. NO B.S. THAT&apos;S WHAT WE DO.
      </Text>
    </View>
  </>
);
